import { render } from "./Sendmail.vue?vue&type=template&id=113c2d17"
import script from "./Sendmail.vue?vue&type=script&lang=js"
export * from "./Sendmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__